import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { CIP_APP_URL } from '../components/config';

const RedirectToCipPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { currentUser, loading } = useContext(AuthContext);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const redirected = useRef(false);
  const popup = searchParams.get('popup') === '1';
  const state = searchParams.get('state') || '';
  let target;
  let targetError = '';
  try {
    const configured = new URL(CIP_APP_URL);
    const callback = new URL(searchParams.get('redirectUri'));
    if (!['http:', 'https:'].includes(configured.protocol) || callback.origin !== configured.origin
      || callback.pathname !== '/auth/rsmin-callback' || callback.username || callback.password
      || callback.hash || (popup && !/^[a-f0-9]{64}$/.test(state))) {
      throw new Error('Invalid callback');
    }
    target = callback;
  } catch {
    targetError = 'This CIP sign-in link is invalid or does not match the configured CIP site. Return to CIP and try again.';
  }
  const callbackUrl = target?.href;

  useEffect(() => {
    if (loading || targetError || redirected.current) return;
    if (!currentUser || !localStorage.getItem('authToken')) {
      const returnTo = `${window.location.pathname}${window.location.search}`;
      navigate(`/login?${new URLSearchParams({ returnTo })}`, { replace: true });
      return;
    }
    if (!popup) {
      redirected.current = true;
      const url = new URL(callbackUrl);
      searchParams.forEach((value, key) => { if (key !== 'redirectUri' && key !== 'token') url.searchParams.set(key, value); });
      url.searchParams.set('token', localStorage.getItem('authToken'));
      window.location.replace(url.href);
    }
  }, [loading, currentUser, targetError, callbackUrl, popup, navigate, searchParams]);

  const connect = () => {
    setError('');
    const token = localStorage.getItem('authToken');
    if (!currentUser || !token) {
      setError('Your RSMIN session has ended. Return to CIP and start sign-in again.');
      return;
    }
    if (!window.opener || window.opener.closed) {
      setError('The CIP window is no longer connected. Return to CIP and try again.');
      return;
    }
    window.opener.postMessage({ type: 'rsmin:signin', state, token }, target.origin);
    setSent(true);
  };

  return (
    <div style={{ padding: '2rem', maxWidth: 520, margin: '0 auto', textAlign: 'center' }}>
      <h2>Sign in to CIP with RSMIN</h2>
      {targetError || error ? <p role="alert" style={{ color: '#b91c1c' }}>{targetError || error}</p>
        : loading ? <p role="status">Checking your RSMIN sign-in...</p>
          : popup && currentUser ? <>
            <p>You are signed in to RSMIN. Continue to securely connect this account to CIP.</p>
            <button type="button" onClick={connect} disabled={sent}>Continue to CIP</button>
            {sent && <p role="status">Connecting... This window will close when CIP finishes signing you in.</p>}
          </> : <p role="status">Preparing your RSMIN sign-in...</p>}
    </div>
  );
};

export default RedirectToCipPage;
